import { Outlet, useLocation } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { Topbar } from './Topbar';
import { useAuthStore } from '@/stores/auth.store';

/**
 * RAD Finance — AppLayout
 * --------------------------------------------------------------------------
 * Shell autenticado, alinhado ao design system do RAD PBX. Sidebar fixa à
 * esquerda + Topbar no topo + área de conteúdo rolável que recebe o <Outlet />.
 * Cada navegação dispara um fade sutil no conteúdo (CSS, via key do pathname)
 * — sem framer-motion.
 *
 * Variantes `print:` — na impressão (relatórios) o shell vira fluxo de
 * documento: sidebar/topbar somem e os contêineres de altura fixa são
 * liberados, senão o navegador imprime só a primeira página do conteúdo.
 */
export function AppLayout() {
  const { pathname } = useLocation();
  const user = useAuthStore((s) => s.user);

  if (!user) return null;

  return (
    <div className="h-full flex bg-canvas text-fg print:block print:h-auto">
      <div className="contents print:hidden">
        <Sidebar />
      </div>
      <div className="flex-1 flex flex-col min-w-0 print:block">
        <div className="contents print:hidden">
          <Topbar />
        </div>
        <main className="flex-1 overflow-y-auto print:overflow-visible">
          <div key={pathname} className="h-full animate-rad-fade-in print:animate-none print:h-auto">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
}
